import * as form from '../form';
import * as validator from './validator';
import {Template} from '../template';

class Form extends form.Form {
  private readonly validators = [new validator.TextDateValidator(this.form),
                                 new validator.PasswordValidator(this.form)];
  private readonly preview = new Preview(this.form);
  constructor(form: HTMLFormElement) {
    super(form, []);
    for (const preview of Array.from(form.querySelectorAll<HTMLElement>('.preview')))
      preview.style.display = 'none';
  }
  override checkValidity() {
    return this.validators.every(validator => validator.checkValidity());
  }
  protected override async onsubmit() {
    const content = document.querySelector('.content')!;
    content.classList.add('hidden');
    const policy =
      document.querySelector('#policy')!.cloneNode(true) as HTMLElement;
    policy.removeAttribute('id');
    policy.classList.remove('hidden');
    content.after(policy);
    document.documentElement.scrollTop = 0;
    const ok = await new Promise<boolean>(resolve => {
      const ok = policy.querySelector('button.button-modal-ok')!;
      ok.addEventListener('click', () => {
        resolve(true);
      });
      const cancel = policy.querySelector('button.button-modal-cancel')!;
      cancel.addEventListener('click', () => {
        resolve(false);
      });
    });
    policy.remove();
    content.classList.remove('hidden');
    document.documentElement.scrollTop = 0;
    if (ok)
      this.preview.show();
  }
}

class Preview extends form.Preview {
  private locale = {
    en: {
      send: 'Send',
    },
    ja: {
      send: '送信',
    },
  } as const;
  protected readonly pattern = /^user\[/;
  protected override previewForm(form: HTMLFormElement) {
    window.scrollTo(0, 0);
    const next = form.querySelector('.button-with-arrow-right')!;
    const lang = document.documentElement.lang as 'en' | 'ja';
    const locale = this.locale[lang];
    next.textContent = locale.send;
    const back = form.querySelector('.button-with-arrow-left')!;
    back.addEventListener('click', event => {
      event.preventDefault();
      this.hide();
      window.scrollTo(0, 0);
    });
    this.preview(form['user[password]'], element => {
      element.textContent = '*********';
    });

    for (const nopreview of Array.from(form.querySelectorAll<HTMLElement>('.nopreview')))
      nopreview.style.display = 'none';
    for (const preview of Array.from(form.querySelectorAll<HTMLElement>('.preview')))
      preview.style.display = '';
    super.previewForm(form);
  }
}

form.Form.register('signup-activate', Form);

class SignupActivatePage {
  static page: SignupActivatePage;
  readonly template: Template;
  constructor() {
    const element = document.querySelector('#signup') as HTMLElement;
    const root = element.parentElement!;
    element.remove();
    this.template = new Template(element, root, this);
  }
  onchangenamekana(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.trim().normalize('NFKC').
      replace(/ /g, '\u3000').
      replace(/[\u3041-\u3096]/g, c => {
        const code =
          c.charCodeAt(0) - '\u3041'.charCodeAt(0) + '\u30a1'.charCodeAt(0);
        return String.fromCharCode(code);
      }).replace(/[^\u3000\u30a0-\u30ff]*/g, '');
  }
  onchangenameinenglish(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value =
      input.value.trim().normalize('NFKC').replace(/[^ -~]*/g, '');
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const split = location.pathname.split('/');
  if (split[2] == 'signup' && split[3] == 'activate')
    SignupActivatePage.page = new SignupActivatePage;
});
